import AssignmentIcon from '@mui/icons-material/Assignment';
import CampaignIcon from '@mui/icons-material/Campaign';
import DescriptionIcon from '@mui/icons-material/Description';
import EventIcon from '@mui/icons-material/Event';
import FolderIcon from '@mui/icons-material/Folder';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import StarsOutlinedIcon from '@mui/icons-material/StarsOutlined';
import WidgetsIcon from '@mui/icons-material/Widgets';
import Box from '@mui/material/Box';
import type { ComponentType } from 'react';

import { KIND_COLOURS, type ArcSection } from './arcTypes';

/*
 * How a section looks in the ARC Builder's wireframe (Part 2, page 4): the
 * icon of what it holds - the side navigation's icon for that section - and a
 * dot, blue for a section of one kind of content, purple for mixed content.
 */

const ICONS: Record<string, ComponentType<{ fontSize?: 'small' | 'medium' }>> = {
  FEATURED: StarsOutlinedIcon,
  CAMPAIGNS: CampaignIcon,
  PETITIONS: HistoryEduIcon,
  EVENTS: EventIcon,
  GUIDES: HowToVoteIcon,
  SURVEYS: AssignmentIcon,
  PAGES: DescriptionIcon,
  DOCUMENTS: FolderIcon,
};

/** The section's icon, as the side navigation draws its kind; custom sections share one. */
export function SectionIcon({ section }: { section: ArcSection }) {
  const Icon = ICONS[section.standard_type ?? ''] ?? WidgetsIcon;
  return <Icon fontSize="small" aria-hidden />;
}

/** The legend's dot: blue for one kind of content, purple for mixed. Decoration only. */
export function KindDot({ mixed }: { mixed: boolean }) {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{
        display: 'inline-block',
        width: 18,
        height: 18,
        flexShrink: 0,
        borderRadius: '50%',
        border: 1.5,
        borderColor: 'text.primary',
        bgcolor: mixed ? KIND_COLOURS.mixed : KIND_COLOURS.standard,
      }}
    />
  );
}
